module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MENU DE NAVEGAÇÃO")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Início")])])]), _vm._v(" "), (this.hasPermission(['contrato.read', 'agenda.read', 'relatorio.solicitacao', 'relatorio.escalas', 'relatorio.ofertas', 'relatorio.usuarios'])) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("ADMINISTRAÇÃO")]) : _vm._e(), _vm._v(" "), (this.hasPermission('contrato.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/contratos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Contratos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('agenda.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/agendas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Agenda")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['relatorio.solicitacao', 'relatorio.escalas', 'relatorio.ofertas', 'relatorio.usuarios', 'relatorio.agenda.prestador'])) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.hasPermission('relatorio.escalas')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/escalas"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Escalas")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.ofertas')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.hasPermission('relatorio.ofertas')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/ofertas"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Procedimentos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.ofertas')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/ofertas-anual"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Procedimentos (Anual)")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.ofertas')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/ofertas-subgrupos-anual"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Subgrupos (Anual)")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.usuarios')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/usuarios"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Relação de Usuários")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.agenda.prestador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/agenda-prestador"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Agenda do prestador")])])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel == 'administrador') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/consumo-limites"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Consumo Limites")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.solicitacao')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.hasPermission('relatorio.solicitacao')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/solicitacoes"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Analítico")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.solicitacao')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/solicitacoes-sintetico"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Sintético")])])]) : _vm._e()], 1)]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (this.hasPermission('contrato.write')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/parametros"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Parâmetros Gerais")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('contrato.write')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/comunicados"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Comunicados")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['distribuicao.read', 'distribuicao.contrato.read', 'distribuicao.agenda.read'])) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("DISTRIBUIÇÃO")]) : _vm._e(), _vm._v(" "), (this.hasPermission('distribuicao.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/distribuicao/distribuir"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-share-alt-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Distribuir")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('distribuicao.contrato.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/distribuicao/controle-contratos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Controle de Contratos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('distribuicao.agenda.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/distribuicao/controle-atendimentos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Controle da Agenda")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['solicitacao.write', 'solicitacao.read', 'solicitacao.regular', 'solicitacao.atendidoFalta'])) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("ATENDIMENTOS")]) : _vm._e(), _vm._v(" "), (this.hasPermission('solicitacao.write')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/atendimentos/solicitacao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Solicitar")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('solicitacao.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/atendimentos/verificacao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Verificar")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('solicitacao.regular')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/atendimentos/regulacao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-stethoscope"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Regular")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('solicitacao.atendidoFalta')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/atendimentos/atendido-falta"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Atendido/Falta")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['paciente.read', 'profissional.read', 'unidade.read', 'grupo.read', 'subgrupo.read', 'forma.organizacao.read', 'procedimento.read'])) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("CADASTROS")]) : _vm._e(), _vm._v(" "), (this.hasPermission('paciente.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/pacientes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pacientes")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('profissional.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/profissionais"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Profissionais")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('unidade.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/unidades"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Unidades")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('unidade.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/preparos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bolt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Preparos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['grupo.read', 'subgrupo.read', 'forma.organizacao.read', 'procedimento.read'])) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.hasPermission('grupo.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/grupos-procedimento"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Grupos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('subgrupo.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/subgrupos-procedimento"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Subgrupos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('forma.organizacao.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/formas-organizacao-procedimento"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Forma de Organização")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('procedimento.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/procedimentos"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Procedimentos")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (this.hasPermission('usuario.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/usuarios"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuários do Sistema")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('paciente-integracao.read')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("INTEGRAÇÃO COM O SISTEMA ANTIGO")]) : _vm._e(), _vm._v(" "), (this.hasPermission('paciente-integracao.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/integracao/pacientes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pacientes")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', [_vm._v("Ofertas")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', [_vm._v("Solicitações")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v(" "), _c('span', [_vm._v("Procedimentos")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6dbccf81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 865
// module chunks = 0